import React from 'react';
import { ChevronRight } from 'lucide-react';
const Dashboard = () => {

    return (
        <div className="flex h-screen bg-white text-gray-800">
            <div className="flex-1 flex flex-col">
                {/* Breadcrumb */}
                <div className="border-b border-gray-200 p-4 flex items-center gap-2 text-sm">
                    <span className="text-gray-500">Dashboard</span>
                    <ChevronRight size={14} className="text-gray-400" />
                </div>
            </div>
        </div>
    )
}

export default Dashboard